

import useUserRepo from "services/repo/useUserRepo";


export default function useAccessPermissionHook() {
    const { checkPrivilegeUser } = useUserRepo(false);

    const isHasPrivilege = async (privilegeId) => {
        let response = await checkPrivilegeUser({ privilageId: privilegeId });
        if (response?.isValid && response?.statusCode === 200) {
            if (response?.data?.isHavePrivilage) return true
            return false
        }
    }

    return {
        isHasPrivilege
    }
}
